export const insCompBgNames = {
    allianz : "Алианц",
    armeetz : "Армеец",
    bulstrad: "Булстрад",
    dallbogg: "ДаллБогг",
    dzi     : "ДЗИ",
    euroins : "Евроинс",
    generali: "Дженерали",
    groupama: "Групама",
    levins  : "Лев Инс",
    ozkins  : "ОЗК",
    uniqa   : "Уника",
    bulins  : "Бул Инс"
}

export const insCompaniesNames = [
    'allianz',
    'armeetz',
    'bulstrad',
    'dallbogg',
    'dzi',
    'euroins',
    'generali',
    'groupama',
    'levins',
    'ozkins',
    'uniqa',
    'bulins'
]

export const insCompanyTypes = {
    1 : "ЕТ",
    2 : "ООД",
    3 : "ЕООД",
    4 : "АД",
    5 : "ЕАД",
    6 : "СД",
    7 : "КД",
    8 : "КДА",
    9 : "ХОЛДИНГ",
    10: "Друго"
}